<template>
  <el-dialog
    v-model="dialogVisible"
    :title="title"
    :width="width"
    :center="center"
    :align-center="position === 'center'"
    :modal-class="position === 'left' ? 'form-dialog-position-left' : ''"
    :destroy-on-close="destroyOnClose"
    :draggable="draggable"
    :close-on-click-modal="closeOnClickModal"
    :close-on-press-escape="false"
  >
    <!-- 默认插槽：对话框内容 -->
    <slot></slot>

    <template #footer>
      <span class="dialog-footer">
        <el-button v-if="showCancelButton" @click="handleCancel">
          {{ cancelText }}
        </el-button>
        <el-button v-if="showConfirmButton" type="primary" @click="submit" :loading="btnLoading">
          {{ confirmText }}
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref } from 'vue'

// 对话框是否显示
const dialogVisible = ref(false)

// 确认按钮加载 loading
const btnLoading = ref(false)
// 显示 loading
const showBtnLoading = () => (btnLoading.value = true)
// 隐藏 loading
const closeBtnLoading = () => (btnLoading.value = false)

// 对外暴露属性
const props = defineProps({
  title: String,
  center: {
    type: Boolean,
    default: true
  },
  width: {
    type: String,
    default: '40%'
  },
  destroyOnClose: {
    type: Boolean,
    default: false
  },
  confirmText: {
    type: String,
    default: '提交'
  },
  cancelText: {
    type: String,
    default: '取消'
  },
  /** 是否显示确认按钮 */
  showConfirmButton: {
    type: Boolean,
    default: true
  },
  /** 是否显示取消按钮（关闭按钮） */
  showCancelButton: {
    type: Boolean,
    default: true
  },
  /** 是否可拖拽 */
  draggable: {
    type: Boolean,
    default: true
  },
  /** 点击遮罩是否关闭 */
  closeOnClickModal: {
    type: Boolean,
    default: false
  },
  /** 弹窗位置：center 居中，left 靠左 */
  position: {
    type: String,
    default: 'center',
    validator: (v) => ['center', 'left'].includes(v)
  }
})

// 打开
const open = () => (dialogVisible.value = true)
// 关闭
const close = () => (dialogVisible.value = false)

const emit = defineEmits(['submit', 'close'])

const handleCancel = () => {
  dialogVisible.value = false
  emit('close')
}

const submit = () => {
  emit('submit')
}

// 对外暴露方法
defineExpose({
  open,
  close,
  showBtnLoading,
  closeBtnLoading
})
</script>

<style>
/* 弹窗靠左显示（非 scoped，需作用于 el-dialog 的 overlay） */
.form-dialog-position-left .el-overlay-dialog {
  display: flex !important;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 5vh 0 0 2%;
}
/* center 仅用于标题/底部按钮居中，表单内容仍左对齐 */
.el-dialog--center .el-dialog__body {
  text-align: left;
}
</style>
